import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTestConditionCellRendererComponent } from './data-test-condition-cell-renderer.component';

@NgModule({
  declarations: [DataTestConditionCellRendererComponent],
  imports: [CommonModule],
})
export class DataTestConditionCellRendererModule {}
